import { render, staticRenderFns } from "./CopyRightGerman.vue?vue&type=template&id=5a7440a6&scoped=true"
import script from "./CopyRightGerman.vue?vue&type=script&lang=ts"
export * from "./CopyRightGerman.vue?vue&type=script&lang=ts"
import style0 from "./CopyRightGerman.vue?vue&type=style&index=0&id=5a7440a6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7440a6",
  null
  
)

export default component.exports